import { provider } from "@grassrootly/api/providers";

export type GetPlayerByIdPayload = { id: number };
export type PlayerMinimal = { id: number; name: string | null; profile_picture: string | null };

export const GetPlayerById = async (
  params: GetPlayerByIdPayload
): Promise<PlayerMinimal | null> => provider.Request("/player-by-id", params);
